/* React */
import React, { useRef, useState } from "react";

/* React Spring */
import { useSpring, animated } from "@react-spring/web";

/* Ionic */
import { IonItem, IonIcon } from "@ionic/react";
import { chevronDown, chevronUp } from "ionicons/icons";

/* Utils */
import useClickOutsideHandler from "src/utils/hooks/useClickOutsideHandler";

/* Stylesheet */
import styles from "./DropdownMenu.module.scss";

/* Interfaces */
import { DropdownMenuProps } from "src/shared/interfaces/common/QuickFilter";

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  label,
  disabled,
  children: Children,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [showItems, setShowItems] =
    useState<boolean>(false);

  const handleShowItems = () => {
    setShowItems((prev: boolean) => !prev);
  };

  useClickOutsideHandler({
    ref: ref,
    onClick: () => {
      if (showItems) setShowItems(false);
    },
  });

  const animation = useSpring({
    opacity: showItems ? 1 : 0,
    transform: showItems
      ? "translateY(0px)"
      : "translateY(-10px)",
    maxHeight: showItems ? "200px" : "0px",
    overflow: "hidden",
    config: { tension: 250, friction: 25 },
  });

  return (
    <div ref={ref} className={styles.dropdown_menu}>
      <IonItem
        style={{
          "--background": disabled
            ? "var(--ion-color-light)"
            : undefined,
          "--color": disabled
            ? "var(--ion-color-text-primary)"
            : undefined,
        }}
        className={`${styles.item} ${
          showItems ? styles.active : ""
        }`}
        lines="none"
        button
        disabled={disabled}
        onClick={handleShowItems}
      >
        <div className={styles.label}>{label}</div>
        {!disabled ? (
          <IonIcon
            className={styles.icon}
            icon={showItems ? chevronUp : chevronDown}
            slot="end"
          />
        ) : undefined}
      </IonItem>
      {showItems ? (
        <animated.div
          style={animation}
          className={styles.children_container}
        >
          <Children />
        </animated.div>
      ) : undefined}
    </div>
  );
};

export default DropdownMenu;
